import React from "react";

const DistributeIcon = ({ width = "32.815", height = "26.077" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 32.815 26.077"
    >
      <path
        id="db84"
        d="M263.64,225.678a.478.478,0,0,1,.286.434v9.745a.467.467,0,0,1-.249.411l-7.77,4.079a.481.481,0,0,1-.48,0l-7.775-4.079a.467.467,0,0,1-.249-.411v-9.745a.478.478,0,0,1,.286-.434l1.675-.872v-6.395h-2.63v1.352a.465.465,0,0,1-.466.466h-3.631a.465.465,0,0,1-.466-.466v-3.631a.465.465,0,0,1,.466-.466h3.631a.465.465,0,0,1,.466.466v1.347h3.1a.468.468,0,0,1,.466.466v6.377l3.068-1.6V209.879a.464.464,0,0,1,.461-.466h2.727v-1.352a.465.465,0,0,1,.466-.466h3.631a.465.465,0,0,1,.466.466v3.631a.465.465,0,0,1-.466.466h-3.631a.465.465,0,0,1-.466-.466v-1.347h-2.261v11.886l1.126-.586a.476.476,0,0,1,.494,0l3.184,1.666V220.4a.468.468,0,0,1,.466-.466h4.125v-1.352a.465.465,0,0,1,.466-.466h3.631a.465.465,0,0,1,.466.466v3.631a.465.465,0,0,1-.466.466h-3.631a.465.465,0,0,1-.466-.466v-1.352h-3.659v2.93l3.613,1.882Z"
        transform="translate(240.411 -242.172) rotate(90)"
      />
    </svg>
  );
};

export default DistributeIcon;
